import { motion } from "framer-motion";
import Link from "next/link";
import Image from "next/image";

export const HeaderH1 = (props) => {
  return (
    <h1 className="title is-spaced" style={{ marginBottom: "1.75rem", fontSize: "2.75rem" }}>
      {props.children}
    </h1>
  );
};
export const HeaderH2 = (props) => {
  return (
    <h2
      className="title is-spaced"
      style={{
        fontSize: "1.75rem",
        marginBottom: "1.3250rem",
        marginTop: "2.5rem",
      }}
    >
      {props.children}
    </h2>
  );
};
export const HeaderH3 = (props) => {
  return (
    <h3
      className="title is-spaced"
      style={{
        fontSize: "1.375rem",
        marginBottom: "1.2250rem",
        marginTop: "2.225rem",
      }}
    >
      {props.children}
    </h3>
  );
};

export const Text = (props) => {
  return (
    <p
      className="subtitle"
      style={{
        fontFamily: "Rubik, sans-serif",
        color: "#646F7D",
        fontSize: "1.175rem",
        fontWeight: "400",
        lineHeight: "2rem",
      }}
    >
      {props.children}
    </p>
  );
};

const NextIcon = () => {
  return (
    <svg
      style={{ marginLeft: "8px", marginTop: "2px" }}
      height="20"
      width="20"
      fill="none"
      viewBox="0 0 20 20"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.2929 3.29289C10.6834 2.90237 11.3166 2.90237 11.7071 3.29289L17.7071 9.29289C18.0976 9.68342 18.0976 10.3166 17.7071 10.7071L11.7071 16.7071C11.3166 17.0976 10.6834 17.0976 10.2929 16.7071C9.90237 16.3166 9.90237 15.6834 10.2929 15.2929L14.5858 11L3 11C2.44772 11 2 10.5523 2 10C2 9.44772 2.44772 9 3 9H14.5858L10.2929 4.70711C9.90237 4.31658 9.90237 3.68342 10.2929 3.29289Z"
        fill="#565D65"
        fillRule="evenodd"
      />
    </svg>
  );
};

export const NextButton = ({ cta, textColor, bg, page }) => {
  return (
    <div style={{ width: "100%", display: "flex", marginTop: "6rem" }}>
      <Link href={page}>
        <motion.button
          whileHover={{ scale: 1.035, filter: "brightness(0.95)" }}
          whileTap={{ scale: 0.9875 }}
          transition={{ type: "spring", duration: 0.25 }}
          style={{
            filter: "brightness(1)",
            marginLeft: "auto",
            cursor: "pointer",
            marginTop: "24px",
            border: "none",
            outline: "none",
            borderRadius: "6px",
            height: "54px",
            color: textColor,
            backgroundColor: bg,
            width: "250px",
            fontSize: "18px",
            fontWeight: "500",
            display: "flex",
            alignItems: "center",
            willChange: "transform",
          }}
        >
          <div style={{ margin: "auto", display: "flex", alignItems: "center" }}>
            {cta}
            <NextIcon />
          </div>
        </motion.button>
      </Link>
    </div>
  );
};

export const ImageBlock = ({
  height,
  width,
  src,
  alt,
  lessRounded,
  mtLess = false,
  mtLessExtra = false,
}) => {
  return (
    <div
      className="is-flex"
      style={{
        alignItems: "center",
        marginTop: mtLessExtra ? "0rem" : mtLess ? "1rem" : "4rem",
        marginBottom: "4rem",
      }}
    >
      <div
        style={{
          /* paddingTop: "24px", paddingLeft: "24px", paddingRight: "24px", */ margin: "auto",
          overflow: "hidden",
          borderRadius: lessRounded ? "10px" : "18px",
          boxShadow: "0 2px 8px 0 rgba(205,205,205,0.80), 0 15px 30px -12px rgba(155,168,180,0.50)",
          display: "flex",
        }}
      >
        <Image src={src} width={width} height={height} quality={100} alt={alt} />
      </div>
    </div>
  );
};
